@if (automatedContentUrl) {
  <iframe
    #iframe
    id="curation-panel"
    [src]="automatedContentUrl | safe: 'resourceUrl'"
    (load)="passAuth()"
    scrolling="no"
    width="100%"
    height="100%"
    frameBorder="0"
  ></iframe>
}
